module.exports = __webpack_public_path__ + "static/the-general-theory-of-employment-interest-and-money-3dd0d0478ef68b94d0f62377615c1e0f.jpg";